import script from "./TDSCertificate.vue?vue&type=script&setup=true&lang=js"
export * from "./TDSCertificate.vue?vue&type=script&setup=true&lang=js"

import "./TDSCertificate.vue?vue&type=style&index=0&id=15f75230&lang=css"

const __exports__ = script;

export default __exports__